// The Bloom footer, rendered ONCE globally in App.js so it appears on every
// page — current and future. Do not add a per-page footer; it would duplicate.
const SiteFooter = () => (
    <footer className="site-footer">© {new Date().getFullYear()} Bloom. All rights reserved.</footer>
);

export default SiteFooter;
